import { render } from "./UserEditDialog.vue?vue&type=template&id=71e4cdc2&scoped=true"
import script from "./UserEditDialog.vue?vue&type=script&lang=js"
export * from "./UserEditDialog.vue?vue&type=script&lang=js"

import "./UserEditDialog.vue?vue&type=style&index=0&id=71e4cdc2&scoped=true&lang=css"

import exportComponent from "/home/utogplukkno/www.utogplukk.no/releases/78563473/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71e4cdc2"]])

export default __exports__